import { COUNTRY_CODE, CURRENCY_ID } from './constants';
import { DEFAULT_SEPARATOR_PATTERN } from './config';
export function ifNumberValidThen(input, func, invalidReturn) {
    var num = parseFloat(String(input));
    return isFinite(num)
        ? typeof func === 'function'
            ? func(num)
            : num
        : typeof invalidReturn !== 'undefined'
            ? invalidReturn
            : input;
}
export function getReadableInteger(str, options) {
    var _a = options || {}, _b = _a.separator, separator = _b === void 0 ? ',' : _b, _c = _a.separatorPattern, separatorPattern = _c === void 0 ? DEFAULT_SEPARATOR_PATTERN : _c;
    if (typeof str !== 'string') {
        return '';
    }
    if (typeof separator !== 'string') {
        return str;
    }
    var separatedArr = [];
    var i = str.length;
    var j = 0;
    while (i > 0) {
        var separateCount = separatorPattern[j % separatorPattern.length];
        var strGroup = str.slice(Math.max(i - separateCount, 0), i);
        separatedArr.unshift(strGroup);
        i -= separateCount;
        j++;
    }
    return separatedArr.join(separator);
}
function numToFloat(number) {
    var _a = Number(number)
        .toExponential()
        .split('e')
        .map(function (str) { return +str; }), mant = _a[0], exp = _a[1];
    return {
        mant: mant,
        exp: exp,
    };
}
export function generateZeros(count) {
    var zeros = '';
    for (var i = 0; i < count; i++) {
        zeros += '0';
    }
    return zeros;
}
function toFixed(number, precision) {
    var floatVal = numToFloat(number);
    var newFloatVal = numToFloat(Math.round(+(String(floatVal.mant) + 'e' + String(floatVal.exp + precision))));
    var fixedNumber = String(+(String(newFloatVal.mant) + 'e' + String(newFloatVal.exp - precision)));
    if (precision === 0 || fixedNumber.includes('e')) {
        return fixedNumber;
    }
    var dotPos = fixedNumber.indexOf('.');
    if (dotPos === -1) {
        return fixedNumber + '.' + generateZeros(precision);
    }
    return (fixedNumber + generateZeros(precision - (fixedNumber.length - dotPos) + 1));
}
export function roundDecimal(input, precision) {
    return ifNumberValidThen(input, function (number) {
        return typeof precision === 'number' && precision >= 0 && precision < 100
            ? toFixed(number, precision)
            : number.toString();
    }, '');
}
export function getNumberParts(input, decimalPoint) {
    if (decimalPoint === void 0) { decimalPoint = '.'; }
    if (typeof input === 'string') {
        var integerStartPos = input.search(/^-|\+/) + 1;
        var decimalPos = input.lastIndexOf(decimalPoint);
        return {
            symbol: input.slice(0, integerStartPos),
            integer: input.slice(integerStartPos, decimalPos < 0 ? void 0 : decimalPos),
            decimal: decimalPos < 0 ? void 0 : input.slice(decimalPos + 1),
            decimalPoint: decimalPoint,
        };
    }
    return {
        symbol: '',
        integer: '',
        decimal: '',
        decimalPoint: decimalPoint,
    };
}
export function isCurrencyCode(input) {
    return typeof input === 'string' && input.toUpperCase() in CURRENCY_ID;
}
export function isCountryCode(input) {
    return typeof input === 'string' && input.toUpperCase() in COUNTRY_CODE;
}
